import { render, staticRenderFns } from "./AddOrEditAppointmentByFormAsPage.vue?vue&type=template&id=933e2e7a"
import script from "./AddOrEditAppointmentByFormAsPage.vue?vue&type=script&lang=ts"
export * from "./AddOrEditAppointmentByFormAsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports